import {
  Flex,
  Heading,
  IconButton,
  InfoIcon,
  Popover,
  Text,
} from '@buffer-mono/popcorn'

import type { SummaryMetricItem } from './SummaryMetrics'
import { MetricDifference } from '../MetricDifference'
import { MetricNumber } from '../MetricNumber'

import styles from './SummaryMetrics.module.css'

import type { JSX } from 'react'

interface MetricCardProps {
  metric: SummaryMetricItem
}

function renderValue(value: number, unit: string): JSX.Element {
  if (unit === 'percentage') {
    return <>{value}%</>
  }
  return <MetricNumber value={value} />
}

export function MetricCard({ metric }: MetricCardProps): JSX.Element {
  const label = metric.name ?? metric.displayName ?? metric.type

  return (
    <Flex direction="column" gap="xs" className={styles.metricCard}>
      <Flex
        direction="row"
        gap="2xs"
        align="center"
        fullWidth
        justify="between"
      >
        <Text size="sm" color="subtle">
          {label}{' '}
        </Text>
        <Popover>
          <Popover.Trigger>
            <IconButton
              type="button"
              label={`About ${label}`}
              size="small"
              variant="tertiary"
            >
              <InfoIcon color="subtle" size="xsmall" />
            </IconButton>
          </Popover.Trigger>
          <Popover.Content
            side="top"
            align="center"
            arrow
            className={styles.popoverContent}
          >
            <Flex direction="column" gap="xs">
              <Heading size="sm" as="h2">
                {label}
              </Heading>
              {metric.description ? (
                <Text color="subtle">{metric.description}</Text>
              ) : null}
            </Flex>
          </Popover.Content>
        </Popover>
      </Flex>
      <Flex align="center" gap="xs">
        <Heading as="p" size="lg">
          {renderValue(metric.value, metric.unit)}
        </Heading>
        <MetricDifference
          difference={metric.difference}
          differenceMode={metric.differenceMode}
        />
      </Flex>
    </Flex>
  )
}
